import React, { useState } from 'react'
import './Login.css'

const Login = () => {
  const [flag, setFlag] = useState('sign-in');

  const handleClick = () =>{
    if(flag == 'sign-in')
        setFlag('sign-up');
      else
      setFlag('sign-in');
  }



//   const wrapper = document.querySelector('.wrapper');
// const signUpLink = document.querySelector('.signUp-link');
// const signInLink = document.querySelector('.signIn-link');

// signUpLink.addEventListener('click', () => {
//     wrapper.classList.add('animate-signIn');
//     wrapper.classList.remove('animate-signUp');
// });

// signInLink.addEventListener('click', () => {
//     wrapper.classList.add('animate-signUp');
//     wrapper.classList.remove('animate-signIn');
// });

  return (
    <>
    <section>
    <div className={ flag == 'sign-in' ? 'wrapper animate-signIn' : 'wrapper animate-signUp'}>
        <div className="form-wrapper sign-up">
            <form action="">
                <h2>Sign Up</h2>
                <div className="input-group">
                    <input type="text" required />
                    <label for="">Username</label>
                </div>
                <div className="input-group">
                    <input type="email" required />
                    <label for="">Email</label>
                </div>
                <div className="input-group">
                    <input type="password" required />
                    <label for="">Password</label>
                </div>
                <button type="submit" className="btn-login">Sign Up</button>
                <div className="sign-link">
                    <p>Already have an account? <a href="#" className="signIn-link" onClick={()=>handleClick()}>Sign In</a></p>
                </div>
            </form>
        </div>

        <div className="form-wrapper sign-in">
            <form action="">
                <h2>Login</h2>
                <div className="input-group">
                    <input type="text" required />
                    <label for="">Username</label>
                </div>
                <div className="input-group">
                    <input type="password" required />
                    <label for="">Password</label>
                </div>
                <div className="forgot-pass">
                    <a href="#">Forgot Password?</a>
                </div>
                <button type="submit" className="btn-login">Login</button>
                <div className="sign-link">
                    <p>Don't have an account? <a href="#" className="signUp-link" onClick={()=>handleClick()}>Sign Up</a></p>
                </div>
            </form>
        </div>
    </div>
    </section>
    </>
  )
}

export default Login